import { RequestStatus } from 'features/request/requestSlice';
import { ExportCSVReport } from 'utils/createCSVReportFile';

import type { ReactNode } from 'react';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { ConfirmationDialog } from '../ConfirmationDialog';
import { ErrorHandlingModal } from '../ErrorHandlingModal';

export const DeleteItemFrom = ({
    isOpened,
    closeDeleteModal,
    deleteData,
    deleteStatus,
    deleteError,
    deleteSetData,
    handleDelete,
    handleSuccess,
    modalTextHeader = 'Удаление записи',
    modalTextConfirmation = 'Вы уверены, что хотите удалить запись?',
    modalCancelButtonText = 'Не удалять',
    modalConfirmButtonText = 'Удалить',
}: {
    isOpened: boolean;
    closeDeleteModal: () => void;
    deleteData: any;
    deleteStatus: RequestStatus;
    deleteError: any;
    deleteSetData: (value: any) => void;
    handleDelete: () => void;
    handleSuccess?: () => void;
    modalTextHeader?: string;
    modalTextConfirmation?: string | ReactNode;
    modalCancelButtonText?: string;
    modalConfirmButtonText?: string;
}) => {
    const dispatch = useDispatch();

    const [isSubmitted, setIsSubmitted] = useState(false);

    const confirmDeletingHandler = useCallback(() => {
        setIsSubmitted(true);
        handleDelete();
    }, [handleDelete]);

    const cancelDeletingHandler = useCallback(() => {
        dispatch(deleteSetData(undefined));
        closeDeleteModal();
    }, [deleteSetData, dispatch, closeDeleteModal]);

    const handleCreateReport = useCallback(() => {
        ExportCSVReport(deleteData?.validation);
    }, [deleteData?.validation]);

    const handleCloseErrorModal = useCallback(() => {
        setIsSubmitted(false);
        closeDeleteModal();
    }, [closeDeleteModal]);

    useEffect(() => {
        if (deleteStatus === RequestStatus.SUCCESS && deleteData?.result) {
            dispatch(deleteSetData(undefined));
            handleSuccess?.();
        }
    }, [deleteData?.result, deleteSetData, deleteStatus, dispatch, handleSuccess]);

    return (
        <>
            <ConfirmationDialog
                isOpened={isOpened}
                onSubmit={confirmDeletingHandler}
                onClose={cancelDeletingHandler}
                textHeader={modalTextHeader}
                textConfirmation={modalTextConfirmation}
                cancelButtonText={modalCancelButtonText}
                confirmButtonText={modalConfirmButtonText}
            />
            <ErrorHandlingModal
                titleText={modalTextHeader}
                isSubmitted={isSubmitted}
                statusRequest={deleteStatus}
                dataRequest={deleteData}
                errorsRequest={deleteError}
                handleCloseModalError={handleCloseErrorModal}
                handleCreateReport={handleCreateReport}
            />
        </>
    );
};

DeleteItemFrom.displayName = 'DeleteItemFrom';
